import {ReactNode} from 'react'
import * as B from '../block'
import {AbstractAdmin, defaultConfig, migrate} from './admin'

export const AbstractBlock = B.blockWithInfo(
  {
    name: 'content-blurb',
    displayName: 'AbstractBlock',
    title: 'Abstract',
    defaultConfig,
    Admin: AbstractAdmin,
    migrate,
  },
  ({config: {justification, heading, position, prop}}) => {
    const {tizraId} = B.useBlockContext()
    const content =
      B.useMetaValue({
        as: 'div',
        tizraId,
        prop,
        html: true,
      }) || null

    return (
      <ContentBlock
        content={content}
        heading={heading}
        justification={justification}
        position={position}
      />
    )
  },
)

interface ContentBlockProps {
  content: ReactNode
  heading: ReactNode
  justification: 'left' | 'right' | 'center'
  position: 'left' | 'right' | 'center'
}

// This is reused by MarkdownBlock
export function ContentBlock({
  content,
  heading,
  justification,
  position,
}: ContentBlockProps) {
  const containedHeading = heading && (
    <B.TextContainer variant="wider" textAlign={justification}>
      <B.SectionHeading prose>{heading}</B.SectionHeading>
    </B.TextContainer>
  )

  const containedContent = content && (
    <B.TextContainer variant="wider" textAlign={justification}>
      {content}
    </B.TextContainer>
  )

  return (
    <B.Scene>
      {containedContent && (
        <B.Section
          heading={containedHeading}
          containerProps={{
            display: 'flex',
            flexDirection: 'column',
            alignItems:
              position === 'left'
                ? 'start'
                : position === 'right'
                ? 'end'
                : 'center',
          }}
        >
          {containedContent}
        </B.Section>
      )}
    </B.Scene>
  )
}
